import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { setTokenGetter } from './marketingApi';

// Hosts the marketing pages inside the unified shell. Every page uses the ops design kit.
export default function MarketingLayout() {
  const { getToken } = useAuth();
  useEffect(() => { setTokenGetter(getToken); }, [getToken]);
  return (
    <main className="main-content ops-main">
      <div className="ops-page">
        <Outlet />
      </div>
    </main>
  );
}
